import React, { useEffect } from 'react';
import { setAlternateItemIdContains } from 'redux/services/julia/productCatalogParams';
import { useAppDispatch } from 'redux/store';
import { useDebouncedCallback } from 'use-debounce';
import { FancyInput } from '../Inputs';

export const AlternateItemIdFilter = (): JSX.Element => {
  /* ******************** Hooks ******************** */
  const dispatch = useAppDispatch();

  /* ******************** Functions ******************** */
  const handleChange = useDebouncedCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    dispatch(setAlternateItemIdContains(value || undefined));
  }, 500);

  // Clears state on unmount
  useEffect(() => {
    return (): void => {
      dispatch(setAlternateItemIdContains(undefined));
    };
  }, [dispatch]);

  return <FancyInput placeholder="Alternate Item Id" onChange={handleChange} />;
};
